import {
  FilterDataTypeEnum,
  FilterOperatorEnum,
  IContactListEntity,
  IHttpSearchResponse,
  ISearchFilter,
  ISearchRequest,
} from '@gr/shared/models';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import {
  allEnabledClassifiedContactListSearchOptions,
  allEnabledSendableContactListSearchOptions,
} from '../components/Contacts/types';
import { axiosPost } from '../authAxios';

function getSearchOptions(defaultSearchRequest: ISearchRequest, searchTerm: string): ISearchRequest {
  const searchFilter: ISearchFilter = {
    dataType: FilterDataTypeEnum.STRING,
    fieldName: 'name',
    operator: FilterOperatorEnum.CONTAINS,
    value: searchTerm,
  };
  const nonSearchFilters = defaultSearchRequest.filters.filter((filter) => filter.fieldName !== 'name');

  return {
    ...defaultSearchRequest,
    filters: searchTerm ? [...nonSearchFilters, searchFilter] : nonSearchFilters,
  };
}

function useContactListSearch(variant: 'sendable' | 'classified', defaultSearchRequest: ISearchRequest, searchTerm: string) {
  return useQuery({
    queryKey: ['contact-lists', variant, searchTerm],
    queryFn: async () => {
      const axios = await axiosPost<IHttpSearchResponse<IContactListEntity>>(
        'entities-search',
        getSearchOptions(defaultSearchRequest, searchTerm)
      );
      return axios.data?.data;
    },
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
}

export function useSendableContactLists(searchTerm: string) {
  return useContactListSearch('sendable', allEnabledSendableContactListSearchOptions, searchTerm);
}

export function useClassifiedContactLists(searchTerm: string) {
  return useContactListSearch('classified', allEnabledClassifiedContactListSearchOptions, searchTerm);
}
